// Hero 在 #pjax-main 之外，pjax 不会替换它，服务端那次渲染写下的 .hide 对后续页面就是过期的：
// 从别的页面 pjax 回首页时它还是收起的，从首页 pjax 走时它又留在页顶。
//
// 所以每次页面加载（首屏 + 每次 pjax 完成，onPageLoaded 两处都覆盖）按当前 DOM 重判一次。
// 判据用 #pjax-main 里的 .page-home —— 那正是 frontend/components/page/home.php 的输出，
// 与 Hero 服务端的显示条件（is_home() || is_front_page()）指向同一件事，且它本身会被 pjax 替换；
// 不用 _iro.page.is_home 是因为它只等于 is_home()，前台设成静态页面时对不上。
_iro.hooks.onPageLoaded(() => {
    const hero = document.querySelector("#hero");

    if (hero) {
        hero.classList.toggle("hide", !document.querySelector(".page-home"));
    }
});
